<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-body-1">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-divider></v-divider>
        <div class="row">
          <div class="pl-3 col">
            <v-text-field
              v-model="Search"
              label="Search"
              required
              append-outer-icon="mdi-table-search"
              @click:append-outer="onSearch"
              v-on:keyup.enter="onSearch()"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Title</th>
                    <th class="text-left">ISBN</th>
                    <th class="text-left">Author Name</th>
                    <th class="text-left">Publisher Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.id">
                    <td>{{ item.Title }}</td>
                    <td>{{ item.ISBN }}</td>
                    <td>{{ item.AuthorName }}</td>
                    <td>{{ item.PublisherName }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <Pagination :paging="paging" v-on:next="onNextPage" />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel" v-if="!options.noconfirm"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as api from "@/api";
import Pagination from "@/components/Pagination";
export default {
  name: "PublicationCollections",
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      dialog: false,
      message: null,
      title: null,
      collectionId: {},
      options: {
        color: "primary",
        width: 900,
        zIndex: 200,
        noconfirm: false,
      },
      Search: "",
      paging: { count: 10, page: 1, size: 10, keyword: "" },
    };
  },
  methods: {
    open(title, collectionId) {
      this.dialog = true;
      this.title = title;
      this.collectionId = collectionId;

      console.log(collectionId);
      this.getPublicationByPagin();
    },

    cancel() {
      this.dialog = false;
    },
    onSearch() {
      console.log("onSearch");
      this.paging.keyword = this.Search;
      this.paging.page = 1;
      this.getPublicationByPagin();
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin();
    },
    getPublicationByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin(
            "publications/collection/" + this.collectionId,
            this.paging
          )
          .then((response) => {
            //console.log("aaaa" + response.data);
            //console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PublicationCollections.vue